import {pingSvg as Icon__small__pingSvg} from '../Icon__small/Icon__small--ping.js';

export var ping = {
  name: 'ping',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pingSvg,
};
